import { render, staticRenderFns } from "./PlayerSettings.vue?vue&type=template&id=374f9d1c&scoped=true"
import script from "./PlayerSettings.vue?vue&type=script&lang=js"
export * from "./PlayerSettings.vue?vue&type=script&lang=js"
import style0 from "./PlayerSettings.vue?vue&type=style&index=0&id=374f9d1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374f9d1c",
  null
  
)

export default component.exports